module.exports = __webpack_public_path__ + "img/example-01-processed.d1b2e761.png";